import { SelectedLegComponentSerializer } from '../../components/SelectedLegComponent';
import { LegsValidation } from '../../validations/LegsValidation';
import { StackableFrameHandlerSystem } from '../StackableFrameHandlerSystem';
import { DefaultLegsSystem } from './DefaultLegsSystem';
import { LegSelectionSystem } from './LegSelectionSystem';
import { LegsSystem } from './LegsSystem';
export class LegsFeature {
    constructor(coreApi, defaultLegProductRef, range) {
        const componentDeserializerRegistry = coreApi.entities.core.services.componentDeserializerRegistry;
        componentDeserializerRegistry.register(new SelectedLegComponentSerializer());
        const defaultLegsSystem = new DefaultLegsSystem(coreApi, defaultLegProductRef);
        coreApi.registerSystem(defaultLegsSystem);
        coreApi.registerSystem(new LegsSystem(coreApi, defaultLegsSystem, range));
        coreApi.registerSystem(new LegSelectionSystem(coreApi));
        coreApi.registerSystem(new StackableFrameHandlerSystem(coreApi));
        coreApi.registerValidation(new LegsValidation(coreApi, defaultLegProductRef, range));
    }
}
//# sourceMappingURL=LegsFeature.js.map